import { Component } from "@angular/core";

@Component({
  selector: "service-description",
  templateUrl: "./service-description.component.html",
  styleUrls: ["../../styles.marketing247.css"],
})
export class ServiceDescriptionComponent {}
